import { ColumnDef } from "@tanstack/react-table";

// Helper functions
const formatDateAndTime = (params: any) => {
	if (!params.value) return "";
	const date = new Date(params.value);
	return date.toLocaleString();
};

const enumToStringConverter = (value: string) => {
	if (!value) return "";
	return value
		.split("_")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(" ");
};

// ==================== EMPLOYEE WORK TIME COLUMNS ====================
export const employeeWorkTimeColumns: ColumnDef<any>[] = [
	{
		accessorKey: "payPeriod",
		header: "Pay Period",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => {
			const payPeriod = getValue() as any;
			return payPeriod?.code || "--";
		},
	},
	{
		accessorKey: "timeUnit",
		header: "Time Volume",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ row }) => {
			const timeValue = row.original.timeValue;
			const timeUnit = row.original.timeUnit;
			return `${timeValue} ${enumToStringConverter(timeUnit)}(s)`;
		},
	},
	{
		accessorKey: "createdAt",
		header: "Date Created",
		size: 220,
		minSize: 180,
		maxSize: 300,
		cell: ({ getValue }) => formatDateAndTime({ value: getValue() }),
	},
	{
		accessorKey: "modifiedAt",
		header: "Date Modified",
		size: 220,
		minSize: 180,
		maxSize: 300,
		cell: ({ getValue }) => formatDateAndTime({ value: getValue() }),
	},
];

// ==================== SUPERVISEE WORK TIME COLUMNS ====================
export const superviseeWorkTimeColumns: ColumnDef<any>[] = [
	{
		accessorKey: "employee",
		header: "Employee",
		size: 250,
		minSize: 200,
		maxSize: 400,
		cell: ({ getValue }) => {
			const employee = getValue() as any;
			if (!employee) return "--";
			return (
				<div className="flex items-center space-x-4">
					<img
						src={employee?.photoUrl || "https://via.placeholder.com/40"}
						alt="Employee"
						className="w-10 h-10 rounded-full object-cover"
					/>
					<p className="text-sm truncate">
						{(employee?.firstName || "") + " " + (employee?.lastName || "")}
					</p>
				</div>
			);
		},
	},
	...employeeWorkTimeColumns,
];

// ==================== EMPLOYEE OVERTIME COLUMNS ====================
export const employeeOvertimeColumns: ColumnDef<any>[] = [
	{
		accessorKey: "numberOfHours",
		header: "Number of Hours",
		size: 200,
		minSize: 150,
		maxSize: 300,
	},
	{
		accessorKey: "overtime",
		header: "Overtime Type",
		size: 220,
		minSize: 180,
		maxSize: 300,
		cell: ({ getValue }) => {
			const overtime = getValue() as any;
			return overtime?.name || "--";
		},
	},
	{
		accessorKey: "payPeriod",
		header: "Pay Period",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => {
			const payPeriod = getValue() as any;
			return payPeriod?.code || "--";
		},
	},
	{
		accessorKey: "createdAt",
		header: "Date Created",
		size: 220,
		minSize: 180,
		maxSize: 300,
		cell: ({ getValue }) => formatDateAndTime({ value: getValue() }),
	},
	{
		accessorKey: "modifiedAt",
		header: "Date Modified",
		size: 220,
		minSize: 180,
		maxSize: 300,
		cell: ({ getValue }) => formatDateAndTime({ value: getValue() }),
	},
];

// ==================== SUPERVISEE OVERTIME COLUMNS ====================
export const superviseeOvertimeColumns: ColumnDef<any>[] = [
	{
		accessorKey: "employee",
		header: "Employee",
		size: 250,
		minSize: 200,
		maxSize: 400,
		cell: ({ getValue }) => {
			const employee = getValue() as any;
			if (!employee) return "--";
			return (
				<div className="flex items-center space-x-4">
					<img
						src={employee?.photoUrl || "https://via.placeholder.com/40"}
						alt="Employee"
						className="w-10 h-10 rounded-full object-cover"
					/>
					<p className="text-sm truncate">
						{(employee?.firstName || "") + " " + (employee?.lastName || "")}
					</p>
				</div>
			);
		},
	},
	...employeeOvertimeColumns,
];
